import { EnvService } from "namirasoft-core";
import { NSMarkdown, NSRow } from "namirasoft-site-react";
import { Component, ReactNode } from "react";
import Styles from "./ChatMessage.module.css";

interface ChatMessageProps
{
    title: string;
    message: string;
    markdown: boolean;
    align?: "left" | "right";
    titleRight?: ReactNode;
}

class ChatMessage extends Component<ChatMessageProps>
{
    override render()
    {
        let align = this.props.align ?? "right";
        let className = align === "left"
            ? `${Styles.ns_message} ${Styles.ns_message_left}`
            : Styles.ns_message;

        return (
            <div className={className}>
                <NSRow>
                    <div className={Styles.ns_message_title_row}>
                        <h4 className={Styles.ns_message_title}>{this.props.title}</h4>
                        {this.props.titleRight && (
                            <div className={Styles.ns_message_title_right}>{this.props.titleRight}</div>
                        )}
                    </div>
                </NSRow>
                {
                    this.props.markdown
                        ? <div className={Styles.ns_message_body}>
                            <NSMarkdown
                                text={this.props.message}
                                taskDownloadUrl={(id) =>
                                {
                                    let base = new EnvService("REACT_APP_BASE_URL_EXPERT", true).getString();
                                    return `${base}/task/${id}/download`;
                                }}
                            />
                        </div>
                        : <p className={Styles.ns_message_text}>{this.props.message}</p>
                }
            </div>
        );
    }
}

export default ChatMessage;